import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="logo">Chord Progression Generator</h1>
        <p className="tagline">Providing chord inspiration for music creators</p>
      </div>
    </header>
  );
}

export default Header; 